import axios, { AxiosPromise } from 'axios';
import { IPrintServer } from '../../../@types/model/masterData/printServer/printServer';
import { IPrintServerUpsert } from '../../../@types/model/masterData/printServer/printServerUpsert';


export default class PrintServerHttpService {
    public static getPrintServerData() : AxiosPromise<Array<IPrintServer>> {
        return axios.get(`${API_URL}/v1/PrintServer/GetAllWeb`);
    }

    public static addOrUpdatePrintServer(upsert : IPrintServerUpsert) : AxiosPromise<IPrintServer> {
        return axios.post(`${API_URL}/v1/PrintServer/PostPrintServer`, upsert);
    }

    public static deletePrintServer(printServerId : number) : AxiosPromise<IPrintServer> {
        return axios.delete(`${API_URL}/v1/PrintServer/Delete`, {
            params : { printServerId },
        });
    }
}
